import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import dashboard from '../../images/OurService/dashboard.png';
import design from '../../images/OurService/design.png';
import love from '../../images/OurService/love.png';
import process from '../../images/OurService/process.png';
import settings from '../../images/OurService/setting.png';
import './OurServices.scss';

const OurServices = () => {
    const serviceData = [
        {
            id: 1,
            img: process,
            title: 'Fund Raising',
            des: 'Dolor sit amet, consectetur adipiscing elit. Suspendisse arcu',
        },
        {
            id: 2,
            img: dashboard,
            title: 'Strategy',
            des: 'Dolor sit amet, consectetur adipiscing elit. Suspendisse arcu',
        },
        {
            id: 3,
            img: love,
            title: 'Client Support',
            des: 'Dolor sit amet, consectetur adipiscing elit. Suspendisse arcu',
        },
        {
            id: 4,
            img: design,
            title: 'Market Forecast',
            des: 'Dolor sit amet, consectetur adipiscing elit. Suspendisse arcu',
        },
        {
            id: 5,
            img: design,
            title: 'Design',
            des: 'Dolor sit amet, consectetur adipiscing elit. Suspendisse arcu',
        },
        {
            id: 6,
            img: settings,
            title: 'Product Management',
            des: 'Dolor sit amet, consectetur adipiscing elit. Suspendisse arcu',
        },
    ];
    return (
        <section className="our-service">
            <Container>
                <div
                    className="service-header mb-5"
                    data-aos="zoom-out-right"
                    data-aos-duration="2000"
                >
                    <h1>Our Services</h1>
                    <p>Trusted over 1000+ clients</p>
                </div>
                <Row>
                    {serviceData.map((service) => (
                        <Col
                            lg={4}
                            md={6}
                            className="d-flex align-items-center justify-content-center"
                            key={service.id}
                        >
                            <Card
                                className="service-card"
                                data-aos="zoom-in-up"
                                data-aos-duration="1500"
                            >
                                <div>
                                    <Card.Img variant="top" src={service.img} />
                                </div>
                                <Card.Body>
                                    <h4>{service.title}</h4>
                                    <Card.Text>{service.des}</Card.Text>
                                    <p className="text-more">Learn More</p>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};
export default OurServices;
